export default __webpack_public_path__ + "static/media/fridge.d11d5608.png";